import { createFileRoute } from '@tanstack/react-router'
import { MealsPage } from '@/components/meals-page'

export const Route = createFileRoute('/meals')({ component: MealsPage })
